import React, { Suspense, lazy, forwardRef } from "react";

import Editor from "./Editor";

const Import = lazy<typeof Editor>(() => import("./Editor"));

const LazyEditor = forwardRef<Editor, React.ComponentProps<typeof Editor>>(
  (props, ref) => (
    <Suspense fallback={<div className="chq-edi chq-edi-pb" />}>
      <Import {...props} ref={ref} />
    </Suspense>
  )
);

export default LazyEditor;
